import { LogOut } from 'lucide-react'
import { useAuth } from '@/context/AuthContext'
import { signOut } from '@/lib/firebase'

export function Topbar() {
  const { user } = useAuth()

  return (
    <header
      style={{
        height: 56,
        flexShrink: 0,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-end',
        gap: 16,
        padding: '0 24px',
        borderBottom: '1px solid var(--border)',
      }}
    >
      {user && (
        <>
          <span style={{ fontSize: 13, color: 'var(--text-secondary)' }}>{user.email}</span>
          <button
            onClick={() => signOut()}
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: 6,
              background: 'transparent',
              border: '1px solid var(--border-strong)',
              color: 'var(--text-secondary)',
              borderRadius: 'var(--radius-sm)',
              padding: '6px 10px',
              fontSize: 13,
              cursor: 'pointer',
            }}
          >
            <LogOut size={14} /> Salir
          </button>
        </>
      )}
    </header>
  )
}
